import moment from 'moment'

const FORMAT = 'DD/MM/YYYY'

export function getDDMMYYYY(dateString: string) {
  if (!dateString) {
    return ''
  }
  return moment(dateString).format(FORMAT)
}
